module.exports = __webpack_public_path__ + "img/mastercard.6db6a855.svg";